import styled from '@emotion/styled';
import {Table, TableCell, TableRow, tableCellClasses} from '@mui/material';
import {grey} from '@mui/material/colors';

export const StyledTable = styled(Table)(({theme}) => ({
  borderCollapse: 'collapse',
  '&::-webkit-scrollbar': {
    width: '12px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '6px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
  /* Firefox */
  scrollbarWidth: 'thin',
  scrollbarColor: '#888 #f1f1f1',
}));

export const StyledTableCell = styled(TableCell)(({theme}) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#800000',
    padding: '9px 16px',
    color: theme.palette.common.white,
    zIndex: 1,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: '7px 16px',
  },
  border: '1px solid !important',
  borderColor: `${grey[300]} !important`,
}));

export const StyledTableRow = styled(TableRow)(({theme}) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: grey[200],
  },
  transition: 'all',
  transitionDuration: '0.5s',
}));

export const StyledTableCellBpkDrive = styled(TableCell)(({theme}) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#FFFFFF',
    padding: '16px',
    color: grey[700],
    fontWeight: 600,
    fontSize: 14,
    borderBottom: `2px solid ${grey[300]}`,
  },

  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: '8px 16px',
    color: grey[800],
  },

  borderLeft: 'none',
  borderRight: 'none',
  borderTop: 'none',
  borderBottom: `1px solid ${grey[200]}`,
}));
